import React from 'react';
import './payment-customer-info.scss';
import { isEmpty } from 'lodash';
import { getPaymentStatusIcon } from '../helper';
import { StatusBadge } from '../../components';
import { getPaymentStatusStyle, getPaymentStatusText } from '../../helper';

interface PaymentCustomerInfoProps {
  paymentCustInfo: {
    paymentRefCode?: string;
    customerName?: string;
    status?: string;
  };
}

export const PaymentCustomerInfo: React.FC<PaymentCustomerInfoProps> = ({
  paymentCustInfo,
}) => {
  if (isEmpty(paymentCustInfo)) return null;

  return (
    <div className="payment-card-view">
      <div className="payment-card-view--left">
        <img src={getPaymentStatusIcon(paymentCustInfo?.status ?? '')} />{' '}
        <div className="payment-card-text">
          <span className="payment-card-text--ref font-semibold">
            {paymentCustInfo?.paymentRefCode ?? 'N/A'}
          </span>
          {paymentCustInfo?.customerName && (
            <span className="payment-card-text--customer font-semibold">
              {`By ${paymentCustInfo?.customerName}`}
            </span>
          )}
        </div>
      </div>
      <StatusBadge
        status={getPaymentStatusText(paymentCustInfo?.status ?? '')}
        style={getPaymentStatusStyle(paymentCustInfo?.status ?? '')}
      />
    </div>
  );
};
